var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.06 30.878a.25.25 0 00.356 0L40.895 8.18a.25.25 0 01.355 0l4.076 4.116a.25.25 0 010 .352l-26.91 27.174a.25.25 0 01-.355 0L3.674 25.294a.25.25 0 010-.352l4.076-4.116a.25.25 0 01.356 0l9.955 10.052z"}));
}

Checkmark.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
